module.exports = __webpack_public_path__ + "static/media/smart-key.ed08c27c.webp";